var pdpTotalPriceTimer = null;
var pdpTotalPriceBasePrice = null;
var pdpTotalPriceBaseComparedPrice = null;
var pdpTotalPriceLastProtectionPrice = null;

$(function () {
  $(document).on(
    'click',
    '.spice-spa-addon-product-wrapper .spice-spa-addon-left .spice-spa-addon-checkbox label .needsclick, ' +
      '.js-warranty-complementary-products li, ' +
      '.t4s-form__product .t4s-swatch__item, ' +
      '.xcotton-productProtection-detail-content-item',
    function () {
      scheduleUpdatePdpTotalPrice(120);
    }
  );

  $(document).on(
    'change',
    '.spice-spa-addon-product-wrapper .spice-spa-addon-variant-id, ' +
      '.spice-spa-addon-product-wrapper .spice-spa-addon-checkbox-input',
    function () {
      scheduleUpdatePdpTotalPrice(80);
    }
  );

  initAddonPriceObserver();
  initProductProtectionClickListener();
  initProductProtectionPriceObserver();
  initProductProtectionPricePolling();
  initPdpTotalPriceBasePrice();
  scheduleUpdatePdpTotalPrice(0);
});

function scheduleUpdatePdpTotalPrice(delay) {
  console.log("ok")
  if (pdpTotalPriceTimer) {
    clearTimeout(pdpTotalPriceTimer);
  }

  pdpTotalPriceTimer = setTimeout(function () {
    updatePdpTotalPrice();
    // Addons update price text asynchronously after variant switch.
    setTimeout(updatePdpTotalPrice, 260);
  }, delay || 120);
}

function initAddonPriceObserver() {
  if (typeof MutationObserver === 'undefined') return;

  var addonWrapper = document.querySelector('.spice-spa-addon-product-wrapper');
  if (!addonWrapper) return;

  var observer = new MutationObserver(function (mutations) {
    var shouldUpdate = mutations.some(function (mutation) {
      if (mutation.type === 'characterData') {
        return $(mutation.target).closest('.spice-spa-addon-price-main').length > 0;
      }

      if (mutation.type === 'childList') {
        if ($(mutation.target).closest('.spice-spa-addon-price-main').length > 0) {
          return true;
        }

        for (var i = 0; i < mutation.addedNodes.length; i++) {
          var node = mutation.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if (
            node.classList.contains('spice-spa-addon-price-main') ||
            $(node).find('.spice-spa-addon-price-main').length > 0
          ) {
            return true;
          }
        }
      }

      return false;
    });

    if (shouldUpdate) {
      scheduleUpdatePdpTotalPrice(60);
    }
  });

  observer.observe(addonWrapper, {
    characterData: true,
    childList: true,
    subtree: true
  });
}

function initProductProtectionClickListener() {
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('.xcotton-productProtection-detail-content-item');
    if (!target) return;

    scheduleProductProtectionTotalPriceUpdate();
  }, true);
}

function initProductProtectionPriceObserver() {
  if (typeof MutationObserver === 'undefined') return;

  observeProductProtectionPrice(document.body);
}

function scheduleProductProtectionTotalPriceUpdate() {
  scheduleUpdatePdpTotalPrice(80);
  setTimeout(updatePdpTotalPrice, 250);
  setTimeout(updatePdpTotalPrice, 600);
  setTimeout(updatePdpTotalPrice, 1200);
}

function initProductProtectionPricePolling() {
  setInterval(function () {
    var protectionPrice = getProductProtectionPrice();
    if (protectionPrice === pdpTotalPriceLastProtectionPrice) return;

    pdpTotalPriceLastProtectionPrice = protectionPrice;
    updatePdpTotalPrice();
  }, 300);
}

function isProductProtectionNode(node) {
  if (!node || node.nodeType !== 1) return false;

  return (
    node.className &&
    String(node.className).indexOf('xcotton-productProtection') > -1
  ) || $(node).closest('[class*="xcotton-productProtection"]').length > 0 ||
    $(node).find('[class*="xcotton-productProtection"]').length > 0;
}

function observeProductProtectionPrice(wrapper) {
  var observer = new MutationObserver(function (mutations) {
    var shouldUpdate = mutations.some(function (mutation) {
      if (mutation.type === 'attributes') {
        return mutation.attributeName === 'class' && isProductProtectionNode(mutation.target);
      }

      if (mutation.type === 'characterData') {
        return $(mutation.target).closest('.xcotton-productProtection-detail-content-item-money').length > 0;
      }

      if (mutation.type === 'childList') {
        if (isProductProtectionNode(mutation.target)) return true;

        for (var i = 0; i < mutation.addedNodes.length; i++) {
          if (isProductProtectionNode(mutation.addedNodes[i])) return true;
        }
      }

      return false;
    });

    if (shouldUpdate) {
      scheduleProductProtectionTotalPriceUpdate();
    }
  });

  observer.observe(wrapper, {
    attributes: true,
    attributeFilter: ['class'],
    characterData: true,
    childList: true,
    subtree: true
  });
}

function updatePdpTotalPrice() {
  var total_price_wrapper = $('.pdp-total-price-wrapper');
  var compared_price_class = '.compared-price';
  var basePrices = getPdpTotalBasePrices();
  var price = basePrices.price;
  var compared_price = basePrices.compared_price;
  var warranty_price = stringToNumber($('.js-warranty-complementary-products .grid__item.active .warranty-price').text());
  var addon_price = getAddonPrice()
  var product_protection_price = getProductProtectionPrice()
 
  compared_price = math.add(compared_price, warranty_price, addon_price, product_protection_price)
  if (price) {
    price = math.add(price, warranty_price, addon_price, product_protection_price)
    total_price_wrapper.find('.price').text(numberToPrice(price));
    if (compared_price > price) {
      total_price_wrapper.find(compared_price_class).text(numberToPrice(compared_price)).show();
    } else {
      total_price_wrapper.find(compared_price_class).hide();
    }
  } else {
    total_price_wrapper.find('.price').text(numberToPrice(compared_price)).end()
      .find(compared_price_class).hide();
  }
}

function initPdpTotalPriceBasePrice() {
  var total_price_wrapper = $('.pdp-total-price-wrapper').first();
  var compared_price_wrapper = total_price_wrapper.find('.compared-price').first();
  var currentPrice = priceTextToNumber(total_price_wrapper.find('.price').first().text());
  var currentComparedPrice = priceTextToNumber(compared_price_wrapper.text());

  pdpTotalPriceBasePrice = currentPrice || null;
  pdpTotalPriceBaseComparedPrice = currentComparedPrice || currentPrice || null;
}

function getPdpTotalBasePrices() {
  var price_container = $('.t4s-product__info-container .t4s-product-price').first();
  var salePrice = priceTextToNumber(price_container.find('ins').first().text());
  var comparePrice = priceTextToNumber(price_container.find('del').first().text());
  var regularPrice = priceTextToNumber(price_container.clone().children('del, ins, .t4s-labrl-sale, .t4s-txt-sale').remove().end().text());
  var price = salePrice || regularPrice || pdpTotalPriceBasePrice || priceTextToNumber($('.pdp-total-price-wrapper').first().find('.price').first().text());
  var compared_price = comparePrice || pdpTotalPriceBaseComparedPrice || price;

  return {
    price: price,
    compared_price: compared_price
  };
}

function getAddonPrice() {
  var addon = $('.spice-spa-addon-product-wrapper [type=checkbox]:checked');
  var total = 0;
  
  if(addon && addon.length > 0){
    for(var i=0; i< addon.length; i++) {
      total += stringToNumber($(addon[i]).closest('.spice-spa-addon-product-item').find('.spice-spa-addon-price-main').text())
    }
  }

  return total
}

function getProductProtectionPrice() {
  var checkedItem = $('.xcotton-productProtection-detail-content-item.xcotton-productProtection-detail-checked').first();

  if (!checkedItem.length) {
    var checkedNode = $('.xcotton-productProtection-detail-checked').first();
    checkedItem = checkedNode.closest('.xcotton-productProtection-detail-content-item');
    if (!checkedItem.length) checkedItem = checkedNode;
  }

  var moneyText = checkedItem.find('.xcotton-productProtection-detail-content-item-money').first().text();

  return priceTextToNumber(moneyText);
}

function priceTextToNumber(str) {
  if (!str) return 0;

  var matches = String(str).replace(/,/g, '').match(/-?\d+(?:\.\d+)?/g);
  if (!matches || !matches.length) return 0;

  return stringToNumber(matches[matches.length - 1]);
}

function stringToNumber(str) {
  if(!str) return 0;
  var num = parseFloat(String(str).replace(/[^0-9.-]/g, ''));
  if(isNaN(num)) return 0;
  
  return num;
}

function numberToPrice(price_number) {
  if (typeof price_number !== 'number') return price_number
  
    return currency_symbol.replace('{{amount}}', price_number.toFixed(2))
}